import { useEffect, useState } from "react";
import { api } from "../api";
import { toastMessageConfig } from "../../entities/toastMessageConfig";
import { LicenseBar as UI } from "./ui/LicenseBar";

export const LicenseBar = ({ toastRef }) => {
  const [componentStateValue, setComponentStateValue] = useState({
    status: "loading",
  });

  useEffect(() => {
    (async () => {
      const getClientLicenseObjResponse = await api.client.license.get();

      const { warning, error } = getClientLicenseObjResponse;

      if (warning) {
        toastRef.current.show({
          severity: "warn",
          summary: warning.title,
          detail: warning.message,
          life: toastMessageConfig.life,
        });
        return;
      }

      if (error) {
        toastRef.current.show({
          severity: "error",
          summary: error.title,
          detail: error.message,
          sticky: true,
        });
        return;
      }
      setComponentStateValue({
        status: "success",
        data: { clientLicenseObj: getClientLicenseObjResponse.licence },
      });
    })();
  }, []);

  if (componentStateValue.status === "loading") return <></>;
  if (componentStateValue.status === "error") return <></>;
  if (componentStateValue.status === "success")
    return <UI clientLicenseObj={componentStateValue.data.clientLicenseObj} />;
};
